import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ListItemButton,
  ListItemText,
  Stack,
} from "@mui/material";
import { NavLink } from "react-router";
import { routes } from "./MainRoutes";
import { useTranslation } from "react-i18next";
import { isPrivileged } from "../../util/PrivilegeUtil";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { RESET_CARDS } from "../../redux/reducers/cardReducer";
import { RESET_PERSON_NAME } from "../../redux/reducers/personReducer";
import { RESET_MESSAGES } from "../../redux/reducers/messageReducer";

export function Menu() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const session = useSelector((state: any) => state.session);
  const menuItem = useSelector((state: any) => state.session.menuItem);
  const theme = useSelector((state: any) => state.settings.theme);

  const handleOnClick = (route: any) => {
    if (route === "titles.searchCard" || route === "titles.group") {
      dispatch({ type: RESET_CARDS });
      dispatch({ type: RESET_PERSON_NAME});
      dispatch({ type: RESET_MESSAGES});
    }
  }

  return (
    <Box role="navigation" sx={{ maxWidth: "16vw", marginRight: "1vw", minWidth: "180px" }}>
      {routes.map((routeGroup: any, index: number) =>
        isPrivileged(
          session?.currentUser?.privileges,
          routeGroup.privilege?.name,
          routeGroup.privilege?.action
        ) || session?.currentUser === "" ? (
          <Accordion
            sx={{
              m: 0,
              '&:before': {
                backgroundColor: 'transparent',
              }
            }}
            key={"accordion" + index}
            defaultExpanded
            disableGutters
            elevation={0}
            style={theme === "light" ? { backgroundColor: "#FAFAFA" } : {}}
          >
            <AccordionSummary
              sx={{ m: 0, height: "4rem" }}
              key={"sum" + index}
              aria-controls={"panel1a-content" + index}
              id={"panel1a-header" + index}
              expandIcon={<ExpandMoreIcon />}
            >
              <Stack direction="row" spacing={1}>
                {routeGroup.icon}
                <Typography
                  sx={{ m: 0, opacity: "0.9" }}
                  key={"typography" + index}
                >
                  {t(routeGroup.groupTitle)}
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <List dense disablePadding>
                {routeGroup.routes.map((route: any, i: number) =>
                  isPrivileged(
                    session?.currentUser?.privileges,
                    route.privilege?.name,
                    route.privilege?.action
                  ) || session?.currentUser === "" ? (
                    <li key={"item" + i + route.privilege?.name}>
                      <ListItemButton
                        dense={true}
                        key={"button" + i}
                        className="SideMenuItem"
                        component={NavLink}
                        to={route.path}
                        onClick={() => {handleOnClick(route.title)}}
                        sx={{ m: "0.1rem", height: "2.2rem" }}
                        style={
                          menuItem === t(route.title)
                            ? theme === "light"
                              ? {
                                backgroundColor: "#dbdbdb",
                                borderLeft: "5px solid #e9002c",
                                borderLeftColor: '#e9002c'
                              }
                              : {
                                backgroundColor: "#5A5858",
                                borderLeft: "5px solid #e9002c",
                                borderLeftColor: '#e9002c'
                              }
                            : {}
                        }
                      >
                        <ListItemText sx={{ opacity: "0.9" }} key={"text" + i}>
                          {t(route.title)}
                        </ListItemText>
                      </ListItemButton>
                    </li>
                  ) : null
                )}
              </List>
            </AccordionDetails>
          </Accordion>
        ) : null
      )}
    </Box>
  );
}
